export const formatWeight = (
  value: string | number,
  measureUnit = 'kg',
  decimalFields = 2
): string => {
  return `${Number(value).toFixed(decimalFields)}${measureUnit}`;
};
